import Cookies from "js-cookie";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import ACTIONS, {
  fetchAspPotentialProviders,
  fetchCherryPotentialProviders,
} from "../../redux/action.js";
import axios from "../../shared/axios/axiosProxy.js";
import VacationNotice from "../../shared/components/vacationNotice/VacationNotice.jsx";
import i18n from "../../utils/i18n.js";
import { pushFlowContextToDataLayer } from "../utils/dataLayerFlowContext";
import { ensureSearchExists } from "../utils/ensureSearchExists";
import {
  mergeUtmIntoPayload,
  prepareAspPayload,
  resolveUtmParams,
} from "../utils/utmBootstrap";
import Monitors from "../searchFlowVersionB/components/monitors/monitors.jsx";
import SearchFlowHeader from "../searchFlowVersionB/components/searchFlowHeader/SearchFlowHeader.jsx";
import GeneralError from "../searchFlowVersionB/steps/common/GeneralError.jsx";
import SearchFlowFooterShell from "../searchFlowVersionB/components/searchFlowFooter/SearchFlowFooterShell.jsx";
import { persistIndustryWithFinancialDefaults } from "../searchFlowVersionB/utils/persistIndustryWithFinancialDefaults.js";
import classes from "../searchFlowVersionB/searchFlow.module.scss";
import { checkStateChange } from "./data/searchFlowText.js";
import {
  Industry,
  Needs,
  TaxconForm,
  VafContactForm,
} from "./oldSteps/index.js";
import VafActivityDescription from "./steps/VafActivityDescription.jsx";
import VafContactPage from "./steps/VafContactPage.jsx";
import VafIndustryActivity, {
  vafIndustryHasActivityContent,
} from "./steps/VafIndustryActivity.jsx";
import VafIndustrySelect from "./steps/VafIndustrySelect.jsx";
import VafSuccessScreen from "./steps/VafSuccessScreen.jsx";
import { computeVafFlowProgressValue, getVafFlowProgress } from "./utils/vafFlowProgress.js";
import { getVafStepFooterNav } from "./utils/vafStepFooterNav.js";
import { createVafFlowAnalytics } from "./analytics/vafFlowAnalytics.js";
import { normalizeEntryFlowSlug } from "./analytics/vafFlowStepRegistry.js";

const mapStateToProps = (state) => ({
  store: state,
  loading: state.loading,
  company_store: state.company_store,
  match_score_weights: state.match_score_weights,
  potential_providers: state.company_store.potential_providers,
});
const mapDispatchToProps = (dispatch) => ({
  addCompanyInfo: (item) => dispatch(ACTIONS.addCompanyInfo(item)),
  fetchAspPotentialProviders: (companyData, msWeights) =>
    dispatch(fetchAspPotentialProviders(companyData, msWeights)),
  fetchCherryPotentialProviders: (companyData, msWeights) =>
    dispatch(fetchCherryPotentialProviders(companyData, msWeights)),
});
const USE_WIREFRAME_ROUTE = true;

const ENABLE_VAF_FLOW_MONITORS = false;

const WIREFRAME_STEPS = [
  {
    component: VafIndustrySelect,
    extraProps: (self) => ({
      selectedIndustry: self.props.company_store?.industry || "",
      industryInput: self.props.company_store?.industryinput || "",
      setIndustrySelection: self.setIndustrySelection,
      setIndustryInput: self.setIndustryInput,
    }),
  },
  { component: VafIndustryActivity },
  { component: VafActivityDescription },
  {
    component: VafContactPage,
    extraProps: (self) => ({
      createAspRequest: self.createAspRequest,
      onRequestError: self.handleContactPageRequestError,
    }),
  },
  { component: VafSuccessScreen },
  { component: GeneralError },
];

const VAF_FLOW_STEPS = [
  { component: Needs },
  { component: Industry },
  { component: TaxconForm },
  {
    component: VafContactForm,
    extraProps: (self) => ({
      onRequestSent: self.handleSearchRequestSent,
    }),
  },
];

const STEPS = USE_WIREFRAME_ROUTE ? WIREFRAME_STEPS : VAF_FLOW_STEPS;

const getStepIncrement = (fromComponent, toComponent) => {
  const fromIndex = STEPS.findIndex((s) => s.component === fromComponent);
  const toIndex = STEPS.findIndex((s) => s.component === toComponent);
  return fromIndex >= 0 && toIndex >= 0 ? toIndex - fromIndex : 1;
};

class VafFlowVersionB extends React.Component {
  analyticsSessionStarted = false;
  flowCompleteTracked = false;
  flowAnalytics = null;

  constructor(props) {
    super(props);
    // Only show a Back button on VafIndustrySelect when we know where "back" leads —
    // i.e. the visitor was routed here from searchFlowVersionB's NewCompanyType step.
    // A direct landing (webflow link, A/B roll on /company/request/vaf) has nowhere
    // sensible to go back to, so the button stays hidden there instead of dropping
    // the user at the flow start.
    const urlParams = new URLSearchParams(window.location.search);
    this.state = {
      activeStep: 0,
      cameFromNewCompanyType: urlParams.get("entry") === "newCompanyType",
      reqID: "",
      cherryID: "",
      searchID: "",
      completedSteps: 0,
      kNetPlusSent: false,
      helpForm: false,
      stepData: `1 - ${new Date().toLocaleTimeString(
        i18n.t("general.countryformat"),
        {
          hour12: false,
        },
      )}`,
      viewedProviders: [],
      vacatiOn: false,
      bookkeepie_id: Cookies.get("bookkeepie_id") || null,
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      utm_content: "",
      utm_term: "",
      gclid: "",
      dclid: "",
      vafProgressValue: null,
      vafProgressStep: null,
    };
  }

  dataLayerUpdate(stepData, event) {
    window.dataLayer.push({
      event: event,
      step: stepData,
      event_category: "vafflow",
    });
  }

  bkIdDataLayerUpdate(stepData, event) {
    window.dataLayer.push({
      event: event,
      bookkeepie_id: stepData,
      event_category: "vafflow",
    });
  }

  dataLayerVersionUpdate() {
    pushFlowContextToDataLayer({
      version: "B",
      flow: "vafflow",
      company_store: this.props.company_store,
    });
  }

  componentDidMount() {
    let bkID = Cookies.get("bookkeepie_id");
    const { company_store, addCompanyInfo } = this.props;

    window.addEventListener("pagehide", this.handlePageHide);

    // Freeze the progress bar to whatever industry value exists right now, so it
    // doesn't shift while the user is still deciding on VafIndustrySelect itself.
    const initialProgressState = this.getVafProgressStateUpdate(this.state.activeStep);
    if (initialProgressState) {
      this.setState(initialProgressState);
    }

    if (company_store.searchID && company_store.searchID !== "") {
      this.setState({ searchID: company_store.searchID });
    }

    if (
      company_store.utm_source ||
      company_store.utm_medium ||
      company_store.utm_campaign
    ) {
      this.setState({
        utm_source: company_store.utm_source || "",
        utm_medium: company_store.utm_medium || "",
        utm_campaign: company_store.utm_campaign || "",
        utm_content: company_store.utm_content || "",
        utm_term: company_store.utm_term || "",
        gclid: company_store.gclid || "",
        dclid: company_store.dclid || "",
      });
    }

    addCompanyInfo({
      id: "abVersion",
      data: "B",
      stateObject: "company_store",
    });

    // Mirrors searchFlowVersionB's NewCompanyType "vaf" branch (persistLeadType) so a
    // visitor landing here directly — e.g. from a webflow page linking straight to
    // /company/request/vaf — ends up with the same leadtype default as someone routed
    // here through that step. Vaf has no fixed companytype default (that's the
    // "not sure which form" branch), so nothing to set there.
    addCompanyInfo({
      id: "leadtype",
      data: "VAF",
      stateObject: "company_store",
    });
    // VAF requests are always for the "simple tax consulting" service — set it
    // as soon as we know we're in this flow so the SearchSchema reflects it
    // while the user is still filling out the form, not only once the
    // AspRequest is submitted (see createAspRequest below for the same flag).
    // Also explicitly reset accounting/legalentityfounding/taxconsultingcomplex:
    // company_store is redux-persist'ed to localStorage, so a visitor who
    // abandoned e.g. the REG/KFTREG flow earlier could otherwise land here with
    // legalentityfounding still true from that session, contaminating this
    // flow's services array.
    addCompanyInfo({
      id: "taxconsultingsimple",
      data: true,
      stateObject: "company_store",
    });
    addCompanyInfo({
      id: "legalentityfounding",
      data: false,
      stateObject: "company_store",
    });
    addCompanyInfo({
      id: "taxconsultingcomplex",
      data: false,
      stateObject: "company_store",
    });
    addCompanyInfo({
      id: "accounting",
      data: false,
      stateObject: "company_store",
    });
    // Also mirror it into company_store.services: updateSearchData() patches
    // `{...company_store}` wholesale on every step change, so if services stays
    // stale/empty in redux, that later full-object patch overwrites (wipes out)
    // the services array we're about to set on the search doc below.
    addCompanyInfo({
      id: "services",
      data: ["taxconsultingsimple"],
      stateObject: "company_store",
    });

    const patchTaxconsultingsimple = (searchID) => {
      if (!searchID) return;
      // SearchSchema has no standalone `taxconsultingsimple` field — services
      // only persist inside the `services` array (mirrors how the backend
      // builds AspRequest.services from the servicesText keys at submit time).
      axios
        .patch(
          `/api/search/${searchID}`,
          { services: ["taxconsultingsimple"] },
          { headers: { "Content-Type": "application/json" } },
        )
        .catch((error) => {
          console.error(
            "Error saving services to search:",
            error.response?.data || error.message,
          );
        });
    };

    if (!company_store.searchID || company_store.searchID === "") {
      ensureSearchExists({
        flowType: "VAF",
        abVersion: "B",
        company_store,
        addCompanyInfo,
        step: this.state.activeStep + 1,
        stepData: this.state.stepData,
      }).then((searchID) => {
        if (searchID) {
          this.setState({ searchID });
          this.startFlowAnalyticsSession();
          patchTaxconsultingsimple(searchID);
        }
      });
    } else {
      patchTaxconsultingsimple(company_store.searchID);
      this.startFlowAnalyticsSession();
    }
    this.dataLayerUpdate(this.state.activeStep, "sf_step_changed");
    this.dataLayerVersionUpdate();

    if (!bkID) {
      bkID = uuidv4();
      this.setState({ bookkeepie_id: bkID });
      Cookies.set("bookkeepie_id", bkID, { expires: 90 });
      this.props.addCompanyInfo({
        id: "searchUser",
        data: bkID,
        stateObject: "company_store",
      });
      axios
        .post(
          `/api/searchUser`,
          {
            userID: bkID,
            searches: [],
            reqs: [],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          console.log("AXIOS RESPONSE: ", response);
        })
        .catch((error) => {
          console.log("AXIOS ERROR: ", error.response.data);
        });
    } else {
      this.props.addCompanyInfo({
        id: "searchUser",
        data: bkID,
        stateObject: "company_store",
      });
    }
    this.bkIdDataLayerUpdate(bkID, "sf_step_bookkeepie_id");

    let cookie = document.cookie;
    if (!cookie.includes("reqsent")) {
      document.cookie = "reqsent=false";
    }
  }
  componentWillUnmount() {
    window.removeEventListener("pagehide", this.handlePageHide);
  }

  componentDidUpdate(_prevProps, prevState) {
    this.startFlowAnalyticsSession();
    this.handleSearchUpdate(prevState.activeStep);
    // Guard against re-running on every re-render (this component re-renders on
    // every company_store dispatch, e.g. each keystroke) — only sync once per
    // distinct searchID, not on every update.
    const searchID = this.state.searchID;
    if (!searchID || searchID === this.syncedSearchUserId) {
      return;
    }
    this.syncedSearchUserId = searchID;
    let bkID = Cookies.get("bookkeepie_id");
    if (bkID) {
      let searchList = [];
      axios
        .get(`/api/searchUser/${bkID}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          searchList = response.data.searchUser.searches.filter(
            (value) => value !== null,
          );
          const sid = this.state.searchID;
          const sidStr = sid && String(sid).trim();
          if (sidStr && !searchList.some((s) => String(s) === sidStr)) {
            searchList.push(sidStr);
            let uniques = [
              ...new Set(
                searchList.filter((item) => String(item).trim() !== ""),
              ),
            ];
            axios.patch(
              `/api/searchUser/${bkID}`,
              { searches: uniques },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              },
            );
          }
        })
        .catch((error) => {
          console.log("AXIOS ERROR COMPUPDATE: ", error.response);
        });
    }
    if (
      this.state.completedSteps >= 14 &&
      checkStateChange(_prevProps.company_store, this.props.company_store) ===
        true
    ) {
      this.props.fetchAspPotentialProviders(
        this.props.company_store,
        this.props.match_score_weights,
      );
    }
    if (
      this.state.completedSteps >= 15 &&
      this.state.reqID.length > 0 &&
      checkStateChange(_prevProps.company_store, this.props.company_store)
    ) {
      this.props.addCompanyInfo({
        id: "selected_providers",
        data: [],
        stateObject: "company_store",
      });
    }
  }

  getVafProgressStateUpdate = (stepIndex) => {
    const value = computeVafFlowProgressValue(this, stepIndex, STEPS);
    if (value === null) {
      return null;
    }
    return { vafProgressValue: value, vafProgressStep: stepIndex };
  };

  getEffectiveSearchId = () => {
    const id = this.state.searchID || this.props.company_store?.searchID;
    if (!id || id === "undefined" || id === "null") {
      return "";
    }
    return String(id);
  };

  /** entryFlow reflects the ORIGINAL entry into the funnel — frozen backend-side on
   * first write, so this only matters for a direct (non-handoff) landing on vaf. */
  resolveEntryFlow = () => {
    const cs = this.props.company_store || {};
    return normalizeEntryFlowSlug(cs.flowStart || cs.leadtype || "vaf");
  };

  initFlowAnalytics = () => {
    if (this.flowAnalytics) {
      return;
    }
    this.flowAnalytics = createVafFlowAnalytics({
      getSearchId: () => this.getEffectiveSearchId(),
      getSteps: () => STEPS,
      getFlowInstance: () => this,
      entryFlow: this.resolveEntryFlow(),
    });
  };

  /** Unlike searchFlowVersionB, vaf has no value-prop gate — the funnel session
   * opens as soon as a searchID exists (own first step, or a resumed session). */
  startFlowAnalyticsSession = () => {
    if (this.analyticsSessionStarted) {
      return;
    }
    const searchId = this.getEffectiveSearchId();
    if (!searchId) {
      return;
    }
    this.initFlowAnalytics();
    this.analyticsSessionStarted = true;
    this.flowAnalytics.trackSessionStart(0);
    if (this.state.activeStep !== 0) {
      this.flowAnalytics.trackStepEnterCatchUp(this.state.activeStep);
    }
  };

  /** Safety net for terminal events fired before startFlowAnalyticsSession got a chance to run. */
  trackReqSentAnalytics = (reqId) => {
    if (!this.getEffectiveSearchId()) {
      return;
    }
    this.startFlowAnalyticsSession();
    if (!this.flowAnalytics) {
      return;
    }
    this.flowCompleteTracked = true;
    this.flowAnalytics.trackReqSent({ reqId, exitFlow: "vaf" });
  };

  handlePageHide = () => {
    if (!this.flowCompleteTracked && this.analyticsSessionStarted) {
      this.flowAnalytics?.trackAbandonHint();
    }
  };

  handleNext = (increment = 1) => {
    if (this.state.activeStep <= 15) {
      if (this.state.searchID === "") {
        this.submitSearchData();
      }
      const fromStep = this.state.activeStep;
      const nextStep = fromStep + increment;
      this.setState({
        activeStep: nextStep,
        ...(this.getVafProgressStateUpdate(nextStep) || {}),
      });
      this.dataLayerUpdate(nextStep, "sf_step_changed");
      if (this.state.completedSteps < this.state.activeStep) {
        this.setState({
          completedSteps: this.state.completedSteps + increment,
        });
      }
      if (this.analyticsSessionStarted && this.flowAnalytics) {
        this.flowAnalytics.trackNavigation({
          fromStepIndex: fromStep,
          toStepIndex: nextStep,
          direction: "forward",
        });
      }
    }
    window.scrollTo(0, 0);
  };
  handleBack = (decr = 1) => {
    if (this.state.activeStep !== 0) {
      const fromStep = this.state.activeStep;
      const prevStep = fromStep - decr;
      this.setState({
        activeStep: prevStep,
        ...(this.getVafProgressStateUpdate(prevStep) || {}),
      });
      if (this.analyticsSessionStarted && this.flowAnalytics) {
        this.flowAnalytics.trackNavigation({
          fromStepIndex: fromStep,
          toStepIndex: prevStep,
          direction: "back",
        });
      }
    }
    window.scrollTo(0, 0);
  };

  // Navigation helpers
  goTo = (target) => {
    const from = STEPS[this.state.activeStep]?.component;
    this.handleNext(getStepIncrement(from, target));
  };

  goBack = (target) => {
    const from = STEPS[this.state.activeStep]?.component;
    this.handleBack(getStepIncrement(target, from));
  };

  vafIndustryShowsActivityStep = () =>
    vafIndustryHasActivityContent(this.props.company_store?.industry);

  handleVafIndustrySelectBack = () => {
    if (this.analyticsSessionStarted && this.flowAnalytics) {
      this.flowCompleteTracked = true;
      this.flowAnalytics.trackFlowHandoff({ exitFlow: "asp" });
    }
    const searchID = this.state.searchID || this.props.company_store?.searchID;
    const searchIDParam = searchID ? `&searchID=${searchID}` : "";
    window.location.assign(`/company/request/1?resumeStep=newCompanyType${searchIDParam}`);
  };

  handleVafIndustrySelectNext = () => {
    if (this.vafIndustryShowsActivityStep()) {
      this.goTo(VafIndustryActivity);
    } else {
      this.goTo(VafActivityDescription);
    }
  };

  handleVafIndustryActivityBack = () => this.goBack(VafIndustrySelect);
  handleVafIndustryActivityNext = () => this.goTo(VafActivityDescription);

  handleVafActivityDescriptionBack = () => {
    if (this.vafIndustryShowsActivityStep()) {
      this.goBack(VafIndustryActivity);
    } else {
      this.goBack(VafIndustrySelect);
    }
  };
  handleVafActivityDescriptionNext = () => this.goTo(VafContactPage);

  /** Shown when the ASP request fails to send from the contact page (no reqID / network error). */
  handleContactPageRequestError = () => this.goTo(GeneralError);

  setIndustrySelection = (industry) =>
    persistIndustryWithFinancialDefaults({
      industry,
      searchID: this.state.searchID || this.props.company_store?.searchID,
      addCompanyInfo: this.props.addCompanyInfo,
      clearIndustryInputWhenNotOther: true,
    }).catch((error) => {
      console.error(
        "Error saving industry financial defaults to searchSchema:",
        error.response?.data || error.message,
      );
      throw error;
    });

  setIndustryInput = (value) => {
    this.props.addCompanyInfo({
      id: "industryinput",
      data: value,
      stateObject: "company_store",
    });
  };

  createAspRequest = (companyData) => {
    let data = prepareAspPayload(companyData, {
      searchID:
        this.state.searchID ||
        this.props.company_store?.searchID ||
        companyData.searchID ||
        "",
      abVersion: this.props.company_store.abVersion || "B",
    });
    if (data.noofemployees === "") {
      data.noofemployees = 0;
    }
    if (data.incominginvoices === "") {
      data.incominginvoices = 0;
    }
    if (data.outgoinginvoices === "") {
      data.outgoinginvoices = 0;
    }
    // VAF requests are always for the "simple tax consulting" service (mirrors
    // vafFlow's needs.jsx, which forces this unconditionally) so it lands in the
    // AspRequest's services array on the backend.
    data.taxconsultingsimple = true;
    // vaf submissions set callbacksource (see RegistrationContactPage.jsx) to route
    // through the callback endpoint, which is what triggers the flow-specific customer
    // email ("Company - VAF RFP Details") and the internal "VAF igénylés" notification —
    // the plain /api/aspreq endpoint only ever sends the generic ASP accountant-matching emails.
    const endpoint = data.callbacksource
      ? "/api/aspreq/requestcallback/new"
      : "/api/aspreq";
    return axios
      .post(endpoint, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        sessionStorage.setItem("reqEmail", data.email);
        const reqID = response.data.result._id;
        const searchID = response.data.searchID || this.state.searchID;

        console.log("ASP Request created successfully:", {
          reqID: reqID,
          searchID: searchID,
          backendSearchID: response.data.searchID,
          existingSearchID: this.state.searchID,
        });

        return new Promise((resolve, reject) => {
          try {
            this.setState({ reqID: reqID }, () => {
              this.props.addCompanyInfo({
                id: "reqID",
                data: reqID,
                stateObject: "company_store",
              });

              const finish = () => {
                this.handleSearchRequestSent(reqID);
                resolve(response);
              };

              if (response.data.searchID && !this.state.searchID) {
                this.setState({ searchID: response.data.searchID }, () => {
                  this.props.addCompanyInfo({
                    id: "searchID",
                    data: response.data.searchID,
                    stateObject: "company_store",
                  });
                  finish();
                });
              } else {
                finish();
              }
            });
          } catch (err) {
            reject(err);
          }
        });
      })
      .catch((error) => {
        console.error("Failed to create ASP request:", {
          error: error.response?.data || error.message,
          searchID: this.state.searchID,
          email: data.email,
        });
        throw error;
      });
  };

  submitSearchData = () => {
    const cs = this.props.company_store;
    if (!this.state.searchID && cs.searchID) {
      this.setState({ searchID: cs.searchID });
      return;
    }
    if (!this.state.searchID && !cs.searchID) {
      ensureSearchExists({
        flowType: "VAF",
        abVersion: "B",
        company_store: cs,
        addCompanyInfo: this.props.addCompanyInfo,
        step: this.state.activeStep + 1,
        stepData: this.state.stepData,
      }).then((searchID) => {
        if (searchID) this.setState({ searchID });
      });
      return;
    }

    let data = { ...cs };
    data.step = this.state.activeStep + 1;
    data.time = this.state.stepData;
    data.returnedProviders = 0;
    data.screenWidth = `${window.innerWidth}`;
    data.lang = cs.chosenLanguage;
    data.leadtype = "VAF";
    data.flowStart = cs.flowStart || "VAF";
    mergeUtmIntoPayload(
      data,
      this.state,
      resolveUtmParams({ company_store: cs, componentState: this.state }),
    );
    data.abVersion = cs.abVersion || "B";

    const effectiveSearchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (
      effectiveSearchID &&
      effectiveSearchID !== "undefined" &&
      effectiveSearchID !== "null"
    ) {
      axios
        .patch(
          `/api/search/${effectiveSearchID}`,
          {
            leadtype: "VAF",
            flowStart: this.props.company_store.flowStart || "VAF",
            abVersion: this.props.company_store.abVersion || "B",
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          console.log("Search updated: ", response.statusText);
        })
        .catch((error) => {
          console.log("AXIOS ERROR updating search: ", error.response.data);
        });
    } else {
      axios
        .post(`/api/search`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("AXIOS RESPONSE: ", response.statusText);
          this.setState({ searchID: response.data.result._id });
          response.data.result._id &&
            this.props.addCompanyInfo({
              id: "searchID",
              data: response.data.result._id,
              stateObject: "company_store",
            });
        })
        .catch((error) => {
          console.log("AXIOS ERROR: ", error.response.data);
        });
    }
  };

  updateSearchData = (time, reqID = null) => {
    const effectiveSearchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (
      !effectiveSearchID ||
      effectiveSearchID === "undefined" ||
      effectiveSearchID === "null"
    ) {
      return;
    }

    let data = { ...this.props.company_store };
    const timeValue = time ?? this.state.stepData;
    data.lang = this.props.company_store.chosenLanguage;
    if (!this.state.requestSent) {
      data.step = this.state.activeStep + 1;
    }
    data.time = timeValue;
    // Only include reqID if we have a valid value (backend will set it anyway)
    // Don't send empty string which might overwrite backend value
    const actualReqID = reqID || this.state.reqID;
    if (
      actualReqID &&
      actualReqID !== "" &&
      actualReqID !== null &&
      actualReqID !== undefined
    ) {
      data.reqID = actualReqID;
    }
    data.abVersion = this.props.company_store.abVersion || "B";
    mergeUtmIntoPayload(
      data,
      this.state,
      resolveUtmParams({
        company_store: this.props.company_store,
        componentState: this.state,
      }),
    );
    data.distanceWeight = this.props.store.match_score_weights.distanceWeight;
    data.priceWeight = this.props.store.match_score_weights.priceWeight;
    data.reviewWeight = this.props.store.match_score_weights.reviewWeight;
    data.phoneWeight = this.props.store.match_score_weights.phoneWeight;
    data.availabilityWeight =
      this.props.store.match_score_weights.availabilityWeight;
    data.experienceWeight =
      this.props.store.match_score_weights.experienceWeight;
    data.liabilityInsWeight =
      this.props.store.match_score_weights.liabilityInsWeight;
    data.badgeWeight = this.props.store.match_score_weights.badgeWeight;
    if (
      this.props.potential_providers !== undefined &&
      this.props.potential_providers.constructor === Object &&
      this.props.potential_providers.some((e) => e.length !== 0)
    ) {
      let rPCounter = 0;
      this.props.potential_providers.forEach((e) => {
        rPCounter += e.length;
      });

      data.returnedProviders = rPCounter;
      let tempArray = [[], [], []];
      for (let i in this.props.potential_providers) {
        for (let j in i) {
          tempArray[i].push(this.props.potential_providers[i][j].companyname);
        }
      }
      data.providers = tempArray;
    }
    axios
      .patch(`/api/search/${effectiveSearchID}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };

  handleSearchUpdate = (prevStep) => {
    if (this.state.activeStep !== prevStep) {
      let timeString = this.state.stepData.concat(
        `, ${this.state.activeStep + 1} - ${new Date().toLocaleTimeString(
          "hu-HU",
          {
            hour12: false,
          },
        )}`,
      );
      this.setState({
        stepData: timeString,
      });
      if (this.state.activeStep !== 1) {
        this.updateSearchData(timeString);
      }
    }
    if (prevStep === "tableUpdate") {
      this.updateSearchData(this.state.stepData);
    }
  };

  renderStep = () => {
    const stepConfig = STEPS[this.state.activeStep];
    if (!stepConfig || !stepConfig.component) return i18n.t("general.notfound");
    const StepComponent = stepConfig.component;
    const commonProps = {
      handleNext: this.handleNext,
      handleBack: this.handleBack,
    };
    const extra = stepConfig.extraProps ? stepConfig.extraProps(this) : {};
    return <StepComponent {...commonProps} {...extra} />;
  };

  handleSearchRequestSent = (reqID = null) => {
    const timeStamp = this.state.stepData.concat(
      ` Req sent - ${new Date().toLocaleTimeString(
        i18n.t("general.countryformat"),
        {
          hour12: false,
        },
      )}`,
    );
    const actualReqID = reqID || this.state.reqID;
    this.trackReqSentAnalytics(actualReqID);
    this.setState({ stepData: timeStamp }, () =>
      this.updateSearchData(timeStamp, actualReqID),
    );
    // Backend already updates rfpsent and reqID, no need for frontend update
  };

  render() {
    const footerNav = getVafStepFooterNav(this, this.state.activeStep, STEPS);
    const progress = getVafFlowProgress(this, this.state.activeStep, STEPS);
    return (
      <>
        <VacationNotice />
        <div className={`${classes.container} ${classes.routingContainer}`}>
          <SearchFlowHeader hideContinueLater />
          <div className={classes.stepContent}>{this.renderStep()}</div>
          <SearchFlowFooterShell footerNav={footerNav} progress={progress} />
          {ENABLE_VAF_FLOW_MONITORS && <Monitors />}
          <div style={{ display: "none" }}>
            <p>Hidden fields</p>
            <input type="hidden" />
            <br />
            <input type="text" id="utm_source" name="utm_source" />
            <br />
            <input type="text" id="utm_medium" name="utm_medium" />
            <br />
            <input type="text" id="utm_campaign" name="utm_campaign" />
            <br />
            <input type="text" id="utm_content" name="utm_content" />
            <br />
            <input type="text" id="utm_term" name="utm_term" />
            <br />
            <input type="text" id="gclid" name="gclid" />
            <br />
            <input type="text" id="dclid" name="dclid" />
            <br />
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(VafFlowVersionB),
);
